import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What services do you offer for metaverse development?",
    answer: `<p>We provide comprehensive metaverse development services, including 3D environment creation, avatar development, blockchain integration, and immersive experience design.</p>`,
  },
  {
    question: "How can the metaverse benefit my business?",
    answer: `<p>The metaverse offers unique opportunities for enhanced customer engagement, innovative marketing strategies, virtual product demonstrations, and a new platform for e-commerce.</p>`,
  },
  {
    question: "What industries can benefit from metaverse development?",
    answer: `<p>Industries such as gaming, real estate, retail, healthcare, education, and entertainment can leverage the metaverse to create immersive and interactive experiences.</p>`,
  },
  {
    question: "What technologies do you use for metaverse development?",
    answer: `<p>We utilize advanced technologies like Unity, Unreal Engine, blockchain, AR/VR, and AI to build robust and scalable metaverse solutions.</p>`,
  },
  {
    question:
      "How do you ensure the security and privacy of metaverse applications?",
    answer: `<p>We implement stringent security measures, including blockchain for decentralized security, encryption protocols, and regular security audits to ensure data privacy and protection.</p>`,
  },
  {
    question:
      "What is the typical timeline for developing a metaverse project?",
    answer: `<p>The timeline varies based on project complexity, but a typical metaverse development project can range from a few months to over a year, ensuring quality and functionality.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Metaverse Development Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
